module.exports = __webpack_public_path__ + "media/images/noukaweb-ogp-adc3f183322ea55f03846284a672cc6e.jpg";